import React, { useState, useEffect } from 'react';
import { firestore } from './firebase';
import { doc, getDoc } from 'firebase/firestore';
import { useNavigate } from 'react-router-dom';
import './Login.css';

const Login = () => {
  const [loginName, setLoginName] = useState('');
  const [error, setError] = useState(null);
  const navigate = useNavigate();

  const handleKeyDown = (e) => {
    if (e.key === 'Enter') {
      handleLogin();
    }
  };

  useEffect(() => {
    const storedName = localStorage.getItem('workerLoginName');
    if (storedName) {
      navigate('/worker-dashboard');
    }
  }, [navigate]);

  const handleLogin = async () => {
    setError(null);

    const trimmedName = loginName.trim().toLowerCase();
    if (!trimmedName) {
      setError('Bitte Login-Namen eingeben.');
      return;
    }

    try {
      const userRef = doc(firestore, 'users', trimmedName);
      const userSnap = await getDoc(userRef);

      if (!userSnap.exists()) {
        setError('Login-Name nicht erkannt.');
        return;
      }

      localStorage.setItem('workerLoginName', trimmedName);
      window.dispatchEvent(new Event('workerLogin'));

      navigate('/worker-dashboard');
    } catch (err) {
      console.error(err);
      setError('Es ist ein Fehler aufgetreten – bitte erneut versuchen.');
    }
  };

  return (
    <div className="login-container fade-in">
      <div className="login-logo">
        <img src="Logo.png" alt="Logo" />
      </div>

      <div className="login-input-container">
        <input
          className="login-textfield"
          type="text"
          placeholder="hmuster"
          value={loginName}
          onChange={e => setLoginName(e.target.value)}
          onKeyDown={handleKeyDown}
        />

        <button onClick={handleLogin} className="login-button">
          Anmelden
        </button>

        {error && <p className="login-error">{error}</p>}
      </div>

    </div>
  );
};


export default Login;
